import { renderMarkdown } from '@/lib/markdown'
import { avatarUrl } from '@/lib/avatar'
import { formatDateTime } from '@/lib/format'
import type { Message } from '@/types/api'
import { Avatar } from '../Avatar'
import styles from './InboxPage.module.css'

export function MessagePreview({ message: m, onOpen }: { message: Message; onOpen: () => void }) {
  const name = m.member?.nick ?? m.author.global_name ?? m.author.username
  const content = m.content || m.message_snapshots?.[0]?.message.content || m.poll?.question.text || m.embeds[0]?.title || (m.attachments.length ? 'Вложение' : m.sticker_items?.length ? 'Стикер' : 'Сообщение')
  return (
    <button type="button" className={styles.message} onClick={(e) => { e.preventDefault(); onOpen() }}>
      <Avatar initial={name.slice(0, 1).toUpperCase()} color="#5865f2" size={32} src={avatarUrl(m.author.id, m.author.avatar)} />
      <span className={styles.messageBody}>
        <span className={styles.meta}><strong>{name}</strong><time dateTime={m.timestamp}>{formatDateTime(new Date(m.timestamp))}</time></span>
        <span className={styles.content}>{renderMarkdown(content, { inline: true, userName: (id) => m.mentions.find((u) => u.id === id)?.global_name ?? m.mentions.find((u) => u.id === id)?.username })}</span>
        {m.attachments.length ? <span className={styles.source}>{m.attachments.map((a) => a.filename).join(', ')}</span> : null}
      </span>
    </button>
  )
}
